import { Certificate, DropdownVessel } from "../../certificates/models/certificates.interfaces";

const normalizeImoNumber = (imoNumber: string | undefined): string => imoNumber?.trim() ?? "";

export const applyUserSelectedVesselIdentityOnImoMismatch = (
  document: Certificate,
  opsLensDocument: Pick<Certificate, "imoNumber"> | undefined,
  userSelectedVessel: Pick<DropdownVessel, "code" | "imoNumber"> | undefined,
): Certificate => {
  const opsLensImoNumber = normalizeImoNumber(opsLensDocument?.imoNumber);
  const userImoNumber = normalizeImoNumber(userSelectedVessel?.imoNumber);

  if (!userSelectedVessel || !opsLensImoNumber || !userImoNumber || opsLensImoNumber === userImoNumber) {
    return document;
  }

  return {
    ...document,
    imoNumber: userSelectedVessel.imoNumber,
    vesselCode: userSelectedVessel.code,
  };
};
